import { Montserrat_500Medium } from '@expo-google-fonts/montserrat/500Medium';
import { useFonts } from 'expo-font';

export const useFontLoader = () => {
  const [loaded] = useFonts({ Montserrat_500Medium });

  return loaded;
};
